require('./RAPortfolioBox.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const RAPortfolioSelector = require('../commons/RAPortfolioSelector/RAPortfolioSelector');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const CurrencyHelper = require('utilities/currencyHelper');

// @constants
const { EURO_SYMBOL } = require('constants/index');

class RAPortfolioBox extends React.Component {
    buildAccountInfo() {
        return (
            <div>
                <div>
                    <FormattedText
                        className="ra-account-box__item-title"
                        value="raCancelPlan-associatedAccountInfo"
                    />
                    <span className="ra-account-box__item-value">
                        {this.props.accountName}
                    </span>
                </div>
                <div>
                    <FormattedText
                        className="ra-account-box__item-title"
                        value="raCancelPlan-ownerInfo"
                    />
                    <span className="ra-account-box__item-value">
                        {this.props.accountOwner}
                    </span>
                </div>
            </div>
        );
    }

    render() {
        const {
            currentValue,
            portfolios,
            selectedPortfolio,
            onPortfolioChange,
        } = this.props;
        const currentValueAmount = CurrencyHelper.getFormattedString({
            amount: currentValue,
            currency: EURO_SYMBOL,
        });
        const accountInfo = selectedPortfolio ? this.buildAccountInfo() : null;

        return (
            <div className="ra-portfolio-box">
                <div className="row">
                    <div className="col-md-6">
                        <h2 className="ra-portfolio-box__title">
                            <FormattedText value="raAdditionalContribution-raAdditionalContribution_portfolioSelection" />
                        </h2>
                        <RAPortfolioSelector
                            onChangeOption={onPortfolioChange}
                            options={portfolios}
                            selectedPortfolio={selectedPortfolio}
                            isFromNewContribution={true}
                        />
                    </div>
                    <div className="col-md-6 text-right">
                        {accountInfo}
                        <div className="ra-portfolio-box__currency-wrapper">
                            <FormattedText
                                className="ra-account-box__item-title"
                                value="raPortfolioBox-raPortfolioBox_accountValue"
                            />
                            &nbsp;
                            <span className="ra-account-box__item-value">
                                {currentValueAmount}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RAPortfolioBox.propTypes = {
    accountName: PropTypes.string,
    accountOwner: PropTypes.string,
    currentValue: PropTypes.number,
    onPortfolioChange: PropTypes.func.isRequired,
    portfolios: PropTypes.array,
    selectedPortfolio: PropTypes.string,
};

module.exports = RAPortfolioBox;
